<div class="loader" *ngIf="isLoading">
  <div class="loader__wrapper loadingio-spinner-ellipsis-kcheyq6x1dt">
    <div class="ldio-y9xt3imdrsl">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
</div>
